import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按分类浏览91n相关内容，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="flex flex-col items-center text-center p-6 bg-background-50 rounded-lg hover:bg-primary-50 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}